import { Injectable, Provider } from '@angular/core';
import { ConfigurationType, IFeatures } from '@bciti/types';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { ConfigurationService, PatchConfigurationPayload } from '../configuration/configuration.service';
import { FeaturesService } from './features.service';

@Injectable({
    providedIn: 'root',
})
export class FeaturesServiceImpl extends ConfigurationService implements FeaturesService {
    getFeatures(orgTag: string): Observable<IFeatures> {
        return this.getConfigurationByKey(orgTag, ConfigurationType.FEATURES);
    }

    updateFeatures(orgTag: string, features: IFeatures): Observable<IFeatures> {
        return this.patchConfigurations(orgTag, this.generatePayload(features)).pipe(
            take(1),
            map((response) => response.data),
            catchError((error) => error),
        );
    }

    createFeatures(orgTag: string, features: IFeatures): Observable<IFeatures> {
        return this.createConfiguration(orgTag, this.generatePayload(features)).pipe(
            take(1),
            map((response) => response.data),
            catchError((error) => error),
        );
    }

    generatePayload(features: IFeatures): PatchConfigurationPayload<IFeatures> {
        return {
            configuration: {
                key: ConfigurationType.FEATURES,
                data: features,
            },
        };
    }
}

export const FEATURES_SERVICE_PROVIDER_IMPL: Provider = {
    provide: FeaturesService,
    useClass: FeaturesServiceImpl,
};
